import React, {Component} from "react";
import {Progress} from "reactstrap";
import {withTranslation} from "react-i18next";

class ProgressRefresh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progressIntervalValue: 0,
    }
  }

  componentDidMount() {
    this.progressInterval = setInterval(() => this.progressIntervalHandler(), 300);
  }

  componentWillUnmount() {
    clearInterval(this.progressInterval);
  }

  progressIntervalHandler() {
    this.setState((prevState) => {
      let piv = 0
      if (prevState.progressIntervalValue >= 100) {
        piv = 0
        this.props.function()
      } else {
        piv = prevState.progressIntervalValue + 1
      }
      return ({
        progressIntervalValue: piv
      })
    });
  }

  render() {
    return (<React.Fragment>
      <div className="animated-progess">
        <Progress value={this.state.progressIntervalValue} color="primary" className="progress-sm" striped></Progress>
      </div>
    </React.Fragment>);
  }
}

export default withTranslation()(ProgressRefresh);
